
<template>
<div class="widthFull ">

    <div class="container  bgWhite ">
      <!--  CHEBONUS ------------------------------------- -->
      <div v-if="brand == 'CHEBONUS' && !isAuthenticated" class="row justify-content-center ">

        <div  class="col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1">

          <h3 class="mt-md-5 pt-md-5">
            Installa Vaillant e attiva
            <br />CheBonus!
          </h3>

          <h5>
            <!--Usufruisci del servizio CheBonus e fornisci al tuo cliente lo sconto in fattura-->
            Accedi a Vaillant CheBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!
          </h5>
          <!--
          <a class="btn btn-primary btn-lg mr-md-4 mt-5"  href="https://www.vaillant.it/professionisti/prodotti/che-bonus/" target="_blank">Scopri il nuovo servizio</a>
        -->
          <router-link v-if="!isAuthenticated" class="btn btn-primary  mr-md-4 mt-5 btnYellow" to="/registration">
            Registrati subito!
          </router-link>

        </div>

        <div class="col-md-8 headerBack order-1 order-md-2">
          <img class="imf-fluid widthFull" src="../../assets/images/newHome.jpg">
        </div>

      </div>

      <!--  HAPPYBONUS ------------------------------------- -->
      <div v-if="brand == 'HAPPYBONUS' && !isAuthenticated" class="row justify-content-center ">

        <div  class="col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1">

          <h3 class="mt-md-5 pt-md-5">
            HappyBonus
            <br />
          </h3>

          <h5>
            <!--
            Cogli i vantaggi dello sconto in fattura e affidati ad HappyBonus: con noi la cessione del credito è più semplice e conveniente.
          -->
            Accedi a Hermann Saunier Duval HappyBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!

          </h5>
          <!--
          <a class="btn btn-primary btn-lg mr-md-4 mt-5" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }"  href="https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/" target="_blank">Scopri il nuovo servizio</a>
        -->
          <router-link v-if="!isAuthenticated" class="btn btn-primary  mr-md-4 mt-5 btnHSDRed" to="/registration">
            Registrati subito!
          </router-link>

        </div>

        <div class="col-md-8 headerBack order-1 order-md-2 pl-0 pr-0">
          <img class="imf-fluid widthFull" src="../../assets/images/newHomeHSD.jpg">
        </div>

      </div>

      <div class="col-md-12 pr-0 pl-0 csmrtop">
        <div class="row justify-content-center ">
          <img class="img-fluid widthFull" src="../../assets/images/wave.png">
        </div>
      </div>

    </div>

    <areaRiservata />



  </div>

</div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  USER_REQUEST
} from 'actions/user'
import axios from 'axios'

import areaRiservata from '../areaRiservata'

const moment = require('moment')

export default {
  components: {
    areaRiservata
  },
  data() {
    return {
      moment: require('moment'),
      status: 'home',
      id: '',
      brand: process.env.BRAND,
    }
  },
  name: 'home',
  methods: {


    showError(text) {
      this.$swal({
        type: 'error',
        title: text,
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#b61617',

      });
    },


  },
  watch: {

    getProfile: function() {

    },

  },
  mounted: function() {

  },
  beforeUpdate: function() {

  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus', 'getProfile']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading'
    }),
    loading: function() {
      return this.authStatus === 'loading' && !this.isAuthenticated
    }
  },
}
</script>

<style lang="css" scoped>

.btnOverlay{
	margin-top: -350px!important;
}

.csmrtop{
  margin-top: -30px;
}

.headerBack{

/*background: url(../../assets/images/newHome.jpg);*/
background-size: contain;
background-position: top;
background-repeat: no-repeat;
align-items: end;
align-content: end;
align-self: flex-end;
}

.section{
	min-height: calc(100vh - 0px);
}

.howplayBack{

background: url(../../assets/images/howplayBack.jpg);
background-size: cover;
background-position: top;
background-repeat: no-repeat;

}

.servicesBack{

background: url(../../assets/images/servicesBack.jpg);
background-size: cover;
background-position: bottom;
background-repeat: no-repeat;

}



.verySmall {
    font-size: 14px!important;
    padding: 8px!important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: middle;
    margin: 10px;
}
.disabled {
    background: #4d4d4d!important;
}
.back{
	background: #ececec;
}

</style>



// WEBPACK FOOTER //
// src/components/home/index.vue